import { PublicEnds } from 'shared/Constants';
import { APIManager } from 'shared/manager';
import AxiosManager from 'shared/manager/AxiosManager';
import GuestAxiosManager from 'shared/manager/GuestAxiosManager';

const getPolicy = async (): Promise<any> =>
  APIManager.sendGet(PublicEnds.GET_POLICY, true, {}, {}, GuestAxiosManager);

const getAccessToken = async (token: string): Promise<any> =>
  APIManager.sendPost(
    PublicEnds.GET_ACCESS_TOKEN(token),
    {},
    true,
    {},
    {},
    AxiosManager
  );

const getDatasets = async (status: string): Promise<any> =>
  APIManager.sendGet(
    PublicEnds.GET_DATA_SETS(status),
    true,
    {},
    {},
    GuestAxiosManager
  );

const getAiSystem = async (status: string): Promise<any> =>
  APIManager.sendGet(
    PublicEnds.GET_AI_SYSTEM(status),
    true,
    {},
    {},
    GuestAxiosManager
  );
const getFeedbackTypes = async (): Promise<any> =>
  APIManager.sendGet(
    PublicEnds.GET_FEEDBACK_TYPES,
    true,
    {},
    {},
    GuestAxiosManager
  );

const updateFeedback = async (data: any): Promise<any> =>
  APIManager.sendPost(
    PublicEnds.UPDATE_FEEDBACK,
    { ...data },
    true,
    {},
    {},
    GuestAxiosManager
  );

const submitAiSystem = async (data: any): Promise<any> =>
  APIManager.sendPost(
    PublicEnds.SUBMIT_AI_SYSTEM,
    { ...data },
    true,
    {},
    {},
    GuestAxiosManager
  );

export const PublicService = {
  getPolicy,
  getAccessToken,
  getDatasets,
  getAiSystem,
  getFeedbackTypes,
  updateFeedback,
  submitAiSystem,
};
